import React from "react";
import "../../assets/css/UC/evidenceInformation.scss";

import { useTranslation } from "../../contexts/TranslationContext";

import "../../config";
import InfoItem from "./InfoItem";

export default function EvidenceInformation({
  info,
  arrAccounts,
  layout = "single-column"
}) {
  const { language } = useTranslation();

  console.log(info);

  const details = language.details || {};

  const defaultUnknownValue = details.defaultUnknownValue || "N/A";



  const ownerOfThisRecord = arrAccounts.find(acc => acc.User_IDValue === info.User_IDValue && acc.User_ID_ExtValue === info.User_ID_ExtValue);
  const agencyOfThisRecord = arrAccounts.find(acc => acc.User_IDValue === info.User_IDValue && acc.User_ID_ExtValue === "0");

  function GetCategoryName(id) {
    if (!id) return global.config.Defines.CategoryID.TestShoe;

    switch (parseInt(id)) {
      case global.config.Defines.CategoryID.NewShoe:
        return global.config.Defines.CategoryName.NewShoe;
      case global.config.Defines.CategoryID.RecoveredShoe:
        return global.config.Defines.CategoryName.RecoveredShoe;
      case global.config.Defines.CategoryID.TestShoe:
        return global.config.Defines.CategoryName.TestShoe;
      default:
        return global.config.Defines.CategoryName.TestShoe;
    }
  }

  return (
    <main>
      <div className={`info-section evidence-information`}>
        <h4>
          {details.evidenceInformation || "Evidence Information"}
        </h4>

        <div className={`info-grid ${layout}`}>
          {/* First column items */}
          <div className="info-column">
            <InfoItem 
              label={details.caseIncident || "Case/Incident"}
              value={info.ImpressionInfo.CaseIncident}
            />

            <InfoItem 
              label={details.impressionEvidence || "Impression/Evidence"}
              value={info.ImpressionInfo.ImpressionNumber}
            />

            <InfoItem 
              label={details.category || "Category"}
              value={GetCategoryName(info.Category_ID)}
              style={{ display: 'none' }}
            />

            <InfoItem 
              label={details.recoveryEvent || "Recovery Event"}
              value={info.ImpressionInfo.RecoveryEventName}
            />

            <InfoItem 
              label={details.datetimeIncident || "Evidence Number"}
              value={info.ImpressionInfo.DateOfIncidentValue}
            />

            <InfoItem 
              label={details.datetimeUpload || "Upload Date"}
              value={info.UploadedTimeValue + " (GMT)"}
            />

            <InfoItem 
              label={details.datetimeUpdate}
              value={info.UpdatedTimeValue + " (GMT)"}
            />

          </div>

          {/* Second column items */}
          <div className="info-column">
            <InfoItem 
              label={details.locationIncident || "Evidence Number"}
              value={info.ImpressionInfo.LocationOfIncident}
            />

            <InfoItem 
              label={details.country}
              value={info.ImpressionInfo.CountryName}
            />

            <InfoItem 
              label={details.state}
              value={info.ImpressionInfo.StateName}
            />

            <InfoItem 
              label={details.county}
              value={info.ImpressionInfo.CountyName}
            />
            
            <InfoItem 
              label={details.latitude || "Evidence Number"}
              value={info.ImpressionInfo.Latitude.toFixed(6)}
            />

            <InfoItem label={details.longitude || "Longitude"} value={info.ImpressionInfo.Longitude.toFixed(6)} />

          </div>
        </div>
      </div>

      <div className={`info-section evidence-information`} style={{ display: info.Category_ID.toString() === global.config.Defines.CategoryID.TestShoe.toString() ? 'block' : 'none' }}>
        <h4>
          {details.productInformation || "Evidence Information"}
        </h4>

        <div className={`info-grid ${layout}`}>
          {/* First column items */}
          <div className="info-column">
            <InfoItem 
              label={details.make}
              value={info.Make}
            />

            <InfoItem 
              label={details.shoeType}
              value={info.ShoeType}
            />

            <InfoItem 
              label={details.model}
              value={info.Model}
            />
          </div>

          {/* Second column items */}
          <div className="info-column">
            <InfoItem 
              label={details.productID}
              value={info.ProductCode}
            />

            <InfoItem 
              label={details.color}
              value={info.Colors}
            />

            <InfoItem 
              label={details.eventType}
              value={info.ImpressionInfo.EventTypeName}
            />
          </div>
        </div>
      </div>

      {/* Notification Information Section */}
      <div className={`info-section evidence-information`}>
        <h4>
          {details.notificationInformation || "Notification Information"}
        </h4>

        <div className={`info-grid ${layout}`}>
          {/* First column items */}
          <div className="info-column">
            <InfoItem 
              label={details.caseNotes || "Case Notes"}
              value={info.NotificationInfo.CaseNotes}
            />

            <InfoItem 
              label={details.importedBy || "Imported By"}
              value={ownerOfThisRecord ? ownerOfThisRecord.Name : defaultUnknownValue}
            />

            <InfoItem 
              cssClass={"info-item dependent-field"} 
              label={details.phoneNumber || "Phone #"} 
              value={ownerOfThisRecord ? ownerOfThisRecord.Phone : defaultUnknownValue} 
            />

            <InfoItem 
              cssClass={"info-item dependent-field"}
              label={details.email || "Email(s)"}
              value={ownerOfThisRecord ? ownerOfThisRecord.Email : defaultUnknownValue}
            />

            <InfoItem 
              cssClass={"info-item dependent-field"}
              label={details.agency || "Agency"}
              value={agencyOfThisRecord ? agencyOfThisRecord.Name : defaultUnknownValue}
            />
          </div>

          {/* Second column items */}
          {/* <div className="info-column">
            <div className="info-item">
              <label>
                {details.detectiveInvestigatorAssigned || "Detective/Investigator Assigned?"}
              </label>
              <span>
                {info.NotificationInfo.DetectiveInvestigatorAssigned ? (details.yes || "Yes") : (details.no || "No")}
              </span>
            </div>
            <div className="info-item">
              <label>
                {details.detectiveName || "Name"}
              </label>
              <span>
                {info.NotificationInfo.Name}
              </span>
            </div>

            <div className="info-item dependent-field">
              <label>
                {details.detectivePhone || "Phone #"}
              </label>
              <span>
                {info.NotificationInfo.Phone}
              </span>
            </div>

            <div className="info-item dependent-field">
              <label>
                {details.detectiveEmail || "Email(s)"}
              </label>
              <span>
                {info.NotificationInfo.Emails}
              </span>
            </div>

            <div className="info-item dependent-field">
              <label>
                {details.detectiveAgency || "Agency"}
              </label>
              <span>
                {info.NotificationInfo.Agency}
              </span>
            </div>

            <div className="info-item">
              <label>
                {details.emailNotifications || "Email Notifications"}
              </label>
              <span>
                {info.NotificationInfo.EmailsForNotifications}
              </span>
            </div>
          </div> */}
        </div>
      </div>
    </main>
  );
}
